import React from 'react';
import { StyledImage } from './Image.styles';
import {
  ImageWithCustomPropTypes,
  ImageWithDefaultProps,
} from './Image.propTypes';

/**
 * Image component
 *
 * @param {Object} props - Image component props
 * @param {string} props.src - Source URL of the image
 * @param {string} props.alt - Alt text for the image
 * @param {string} [props.loading='lazy'] - Loading attribute for the image, default is 'lazy'
 * @param {number|string} [props.width] - Width of the image
 * @param {number|string} [props.height] - Height of the image
 * @param {Object} [props.style] - Custom styles for the image
 * @param {string} [props.className] - Custom class name for the image
 * @returns {React.Element} React Element
 */
const Image = ({ src, loading = 'lazy', width, height, alt, ...props }) => {
  return (
    <StyledImage
      src={src}
      alt={alt}
      className={'frontity-lazy-image'}
      loading={loading}
      width={width}
      height={height}
      {...props}
    />
  );
};

Image.propTypes = ImageWithCustomPropTypes;
Image.defaultProps = ImageWithDefaultProps;

export default Image;
